import { Box, Divider, Hidden, Page, PageBlock } from 'braid-design-system';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { usePostListingById } from 'src/hooks/usePostListing';

import Confirmation from './components/Confirmation';

const PostListing = () => {
  const { id: listingId } = useParams();
  const postListingById = usePostListingById();

  useEffect(() => {
    if (
      typeof listingId === 'string' &&
      postListingById.status.kind === 'idle'
    ) {
      postListingById.post(listingId);
    }
  }, [listingId, postListingById]);

  const params =
    postListingById.status.kind === 'success'
      ? {
          title: 'Congratulations',
          cardTitle: 'You have successfully posted your business for sale',
          body: 'Call customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) if we can help you with anything else.',
        }
      : {
          title: 'Something went wrong',
          cardTitle: 'Your business for sale has not been posted',
          body: 'Contact customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) for help.',
        };

  return (
    <Page footer={<SiteWideFooter />} footerPosition="belowFold">
      <Header title="Sell your business" />

      <Hidden below="tablet">
        <Divider />
      </Hidden>

      <Box paddingTop="xlarge">
        <PageBlock width="small">
          {postListingById.status.kind === 'loading' ? (
            <CustomLoader />
          ) : (
            <Confirmation {...params} />
          )}
        </PageBlock>
      </Box>
    </Page>
  );
};

export default PostListing;
